// c:\PA\v2_main\counterfeitDashboardV2_PiratesAlert\CounterfeitFront-PiratesAlert\src\views\admin\Uncrawled\components\Xproducts.js

import React, { useEffect, useState } from "react";
import {
  Flex,
  Icon,
  Image,
  Text,
  useColorModeValue,
  Link,
  Button,
  Tooltip,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import Amazon from 'assets/img/amazon.ico';
import Flipkart from 'assets/img/flipkart.ico';
import Snapdeal from 'assets/img/snapdeal.ico';
import Meesho from 'assets/img/meesho.ico';
import Glowroad from 'assets/img/glowroad.ico'
import Shopsy from 'assets/img/shopsy.ico';
import freeup from 'assets/img/freeup.ico';

import { MdAlbum } from "react-icons/md";

export default function XProducts(props) {
  const { product, handleToggleProduct, selectedProducts, index, isAdmin } = props;
  
  const textColor = useColorModeValue("brands.900", "white");
  const bgItem = useColorModeValue(
    { bg: "white", boxShadow: "0px 40px 58px -20px rgba(112, 144, 176, 0.12)" },
    { bg: "navy.700", boxShadow: "unset" }
  );

  const [toggle, setToggle] = useState(false);

  const handleToggle = (pd_id) => {
    const newToggle = !toggle;
    setToggle(newToggle);
    handleToggleProduct(pd_id);
    console.log("pdL:",pd_id)
  };

  useEffect(() => {
    // Check if this product is in selectedProducts
    const isSelected = selectedProducts.some((item) => item.pd_id === product.id);
    setToggle(isSelected);
  }, [selectedProducts, product.id]);

  const getPlatformIcon = (platformId) => {
    switch (platformId) {
      case 1:
        return Amazon;
      case 2:
        return Flipkart;
      case 3:
        return Snapdeal;
      case 4:
        return Meesho;
      case 5:
        return Glowroad;
      case 6:
        return Shopsy;
      case 7:
        return freeup;
      default:
        return null;
    }
  };

  return (
    <Card
      _hover={bgItem}
      bg="transparent"
      boxShadow="unset"
      px="24px"
      py="21px"
      transition="0.2s linear"
    >
      <Flex direction={{ base: "column" }} justify="center">
        <Flex position="relative" align="center">
          {/* Product Image */}
          <Link href={product.image_link} isExternal me="15px">
            <Image src={product.image_link} w="80px" me="16px" h="120px" objectFit="contain" />
          </Link>

          {/* Product Details */}
          <Flex
            direction="column"
            w={{ base: "70%", md: "100%" }}
            me={{ base: "4px", md: "32px", xl: "10px", "3xl": "32px" }}
          >
            <Text
              color={textColor}
              fontSize={{
                base: "md",
              }}
              mb="5px"
              fontWeight="bold"
              me="14px"
            >
              {index + 1}.&nbsp;&nbsp;
              <Link
                href={product.prod_link}
                textDecoration="underline"
                isExternal
              >
                {product.title || product.prod_link}
              </Link>
            </Text>

            <Flex direction="row">
              <Text
                color="secondaryGray.600"
                fontSize={{
                  base: "sm",
                }}
                fontWeight="400"
                me="14px"
              >
                {product.keyword}
                <Tooltip label={product.platform_name}>
                  <Image
                    src={getPlatformIcon(product.platform_id) || `https://www.google.com/s2/favicons?domain=${product.platform_name}&sz=128` || `https://www.${product.platform_name}/favicon.ico`}
                    alt="platform icon"
                    width="15px"
                    display="inline"
                    ml="5px"
                  />
                  </Tooltip>
              </Text>
            </Flex>

            <Flex direction="row">
              <Text
                color="secondaryGray.600"
                fontSize={{
                  base: "sm",
                }}
                fontWeight="400"
                me="14px"
              >
                Product Code:
              </Text>
              <Text
                color={textColor}
                fontSize={{
                  base: "sm",
                }}
                fontWeight="bold"
              >
                {product.prod_code}
              </Text>
            </Flex>

            <Flex direction="row">
              <Text
                color="secondaryGray.600"
                fontSize={{
                  base: "sm",
                }}
                fontWeight="400"
                me="14px"
              >
                Rating:
              </Text>
              <Text
                color={textColor}
                fontSize={{
                  base: "sm",
                }}
                fontWeight="bold"
              >
                {product.overall_rating || "N/A"} ⭐
              </Text>
            </Flex>

            <Flex direction="row">
              <Text
                color="secondaryGray.600"
                fontSize={{
                  base: "sm",
                }}
                fontWeight="400"
                me="14px"
              >
                No. of Ratings:
              </Text>
              <Text
                color={textColor}
                fontSize={{
                  base: "sm",
                }}
                fontWeight="bold"
              >
                {product.no_of_rating || 0}
              </Text>
            </Flex>
          </Flex>

          {/* Select Button */}
          {isAdmin && (
            <Flex
              me={{ base: "4px", md: "32px", xl: "10px", "3xl": "32px" }}
              align="center"
              direction="column"
            >
              <Tooltip label="Select">
                <Button
                  colorScheme="gray"
                  fontSize="20px"
                  p="0px"
                  onClick={() => handleToggle(product.id)}
                >
                  <Icon
                    color={toggle ? "green" : "gray"}
                    as={MdAlbum}
                  />
                </Button>
              </Tooltip>
            </Flex>
          )}
        </Flex>
      </Flex>
    </Card>
  );
}